import { useState } from "react";
import {
  FestivalCompetitionTabWrapper,
  FestivalCompetitionTabItem,
} from "./style";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import { FestivalCompetitionTab } from "../../../../hooks/use-festival-tab";

const RabbitFestivalCompetitionTab = () => {
  const { setCompetitionTab, isCompetitionTab } = useRabbitFestivalContext();
  const [activeTab, setActiveTab] = useState(FestivalCompetitionTab.EVENT);

  const handleClick = (tab: FestivalCompetitionTab) => {
    setCompetitionTab(tab);
    setActiveTab(tab);
  };

  const tabList = [
    { title: "이벤트", tab: FestivalCompetitionTab.EVENT },
    { title: "포스터", tab: FestivalCompetitionTab.POSTER },
    { title: "뉴스", tab: FestivalCompetitionTab.NEWS },
  ];

  return (
    <FestivalCompetitionTabWrapper activeTab={activeTab}>
      {tabList.map((item, index) => (
        <FestivalCompetitionTabItem
          key={index}
          isSelected={isCompetitionTab(item.tab)}
          onClick={() => handleClick(item.tab)}
        >
          {item.title}
        </FestivalCompetitionTabItem>
      ))}
      <div className="background" />
    </FestivalCompetitionTabWrapper>
  );
};

export default RabbitFestivalCompetitionTab;
